import React from "react";

/**
 * Fondo animado corporativo temático de taxis:
 * - Base: gradiente indigo profundo con viñeta
 * - Grid tipo blueprint sutil
 * - 3 carriles con líneas discontinuas moviéndose (efecto autopista)
 * - Taxis SVG cruzando en cada carril a distintas velocidades
 * - Pings de GPS pulsantes (dispatch style)
 * - Órbitas y trazas sutiles
 */
const TaxiIcon = ({ className = "" }) => (
  <svg viewBox="0 0 64 32" xmlns="http://www.w3.org/2000/svg" className={className}
       aria-hidden="true">
    {/* Cuerpo */}
    <path d="M6 22 C6 18, 8 16, 12 15 L18 10 C20 8, 24 7, 32 7 L42 7 C48 7, 52 9, 56 15 L58 15 C60 15, 61 17, 61 19 L61 22 Z"
          fill="#F9C400" stroke="#000" strokeWidth="0.8"/>
    {/* Techo taxi checker */}
    <rect x="26" y="4" width="10" height="3" fill="#000"/>
    <rect x="26" y="4" width="2.5" height="1.5" fill="#F9C400"/>
    <rect x="31" y="4" width="2.5" height="1.5" fill="#F9C400"/>
    <rect x="26" y="5.5" width="2.5" height="1.5" fill="#000"/>
    <rect x="28.5" y="4" width="2.5" height="1.5" fill="#000"/>
    <rect x="33.5" y="4" width="2.5" height="1.5" fill="#000"/>
    {/* Ventanas */}
    <path d="M20 11 L26 8 L38 8 L42 11 Z" fill="#0D1257" opacity="0.8"/>
    <path d="M43 11 L44 8 L52 12 L52 15 Z" fill="#0D1257" opacity="0.8"/>
    {/* Ruedas */}
    <circle cx="17" cy="22" r="4" fill="#111" stroke="#333" strokeWidth="0.5"/>
    <circle cx="17" cy="22" r="1.5" fill="#666"/>
    <circle cx="48" cy="22" r="4" fill="#111" stroke="#333" strokeWidth="0.5"/>
    <circle cx="48" cy="22" r="1.5" fill="#666"/>
    {/* Faro delantero */}
    <rect x="4" y="19" width="2" height="1.5" fill="#FFEE58" rx="0.3"/>
  </svg>
);

export default function TaxiBackground() {
  return (
    <div className="taxi-bg absolute inset-0 overflow-hidden pointer-events-none">
      {/* Gradiente base — navy muy oscuro que hace resaltar el amarillo del logo */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#040817] via-[#070E28] to-[#020614]"></div>

      {/* Grid blueprint */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.08]" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="tx-grid" width="48" height="48" patternUnits="userSpaceOnUse">
            <path d="M 48 0 L 0 0 0 48" fill="none" stroke="white" strokeWidth="1"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#tx-grid)"/>
      </svg>

      {/* Líneas de tráfico horizontales con dashes que se mueven */}
      <div className="lane lane-1"><span className="lane-dash"></span></div>
      <div className="lane lane-2"><span className="lane-dash"></span></div>
      <div className="lane lane-3"><span className="lane-dash"></span></div>
      <div className="lane lane-4"><span className="lane-dash"></span></div>

      {/* Taxis cruzando */}
      <div className="taxi taxi-a"><TaxiIcon className="w-24 h-12"/></div>
      <div className="taxi taxi-b"><TaxiIcon className="w-16 h-8"/></div>
      <div className="taxi taxi-c"><TaxiIcon className="w-28 h-14"/></div>
      <div className="taxi taxi-d"><TaxiIcon className="w-20 h-10"/></div>

      {/* GPS pings (estilo dispatch/mapa) */}
      <div className="gps gps-1"><span></span></div>
      <div className="gps gps-2"><span></span></div>
      <div className="gps gps-3"><span></span></div>

      {/* Blobs indigo suaves para dar profundidad corporativa */}
      <div className="tx-blob tx-blob-a"></div>
      <div className="tx-blob tx-blob-b"></div>

      {/* Órbitas centrales sutiles */}
      <div className="tx-orbit tx-orbit-1"></div>
      <div className="tx-orbit tx-orbit-2"></div>

      {/* Viñeta oscura en bordes */}
      <div className="absolute inset-0 bg-radial-vignette pointer-events-none"></div>
    </div>
  );
}
